export const environment = {
    production: false,
    apiEndpoint: 'https://dev.mavexportacoes.com:5137',
    employeeNames: ['Alexandre Muniz', 'Brenda Carballo', 'Carlos Da Silva', 'Carlos Rodríguez', 'Gabriel Morales',
    'Leonarado Gomez', 'Lorenzo Barrios', 'Luan Gomez', 'Mateo Carneiro', 'Emmanuel Carballo', 'Empleado 1', 'Empleado 2', 'Empleado 3', 'Empleado 4', 'Empleado 5'],
    sparePartDeliveryStatus: ['DEVOLUCION-PROVEEDOR', 'STOCK-ENTREGA-EN-LOCAL', 'STOCK-ENTREGA-AL-CLIENTE',
        'STOCK-OTRAS-EXPORTACIONES-AUTOCOMERCIAL', 'STOCK-OTRAS-EXPORTACIONES-SERIMPORT', 'EMPAQUETADO-OTRAS-EXPORTACIONES-AUTOCOMERCIAL', 'EMPAQUETADO-OTRAS-EXPORTACIONES-SERIMPORT',
         'STOCK-EXPORTACION-ACTUAL-AUTOCOMERCIAL', 'STOCK-EXPORTACION-ACTUAL-SERIMPORT',
          'EMPAQUETADO-EXPORTACION-ACTUAL-AUTOCOMERCIAL', 'EMPAQUETADO-EXPORTACION-ACTUAL-SERIMPORT',
            'EXPORTADO', 'EXPORTADO-NO-CARGADO', 'ENVIADO-AL-TALLER', 'ENTREGADO-EN-LOCAL', 'PENDIENTE A SOLUCIÓN', 'CANCELADO', 'CREADO'],
    sparePartReceptionStatusOptions: ['LLEGO', 'NO-LLEGO'],
    orderStatus: ['CREADO', 'LLEGO', 'FINALIZADO', 'ATENCION', 'REPUESTOS-PENDIENTES', 'PENDIENTE', 'EN PROCESO', 'COMPLETADO', 'CANCELADO'],
    shippingSparePartOptions: ['NO-ENVIADO', 'ENVIADO', 'DEVUELTO'],
    kpiAuthorizedUserIds: [1, 2, 3, 10, 12]
    };
   